import { Injectable } from '@angular/core';

import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Competition_entry_fee } from '../models/accounting/competition_entry_fee';
import { Section_entry_fee } from '../models/accounting/section_entry_fee';

import { AppSettings } from '../app.settings';


@Injectable({
  providedIn: 'root'
})
export class EntryFeeService {

  constructor(private http: HttpClient) { }

  getFeesForEntryInSection(entry_id: string, section_number: number): Promise<Section_entry_fee[]> {
    return this.getWithRest('entry_id/' + entry_id + '/section_number/' + section_number);
  }

  private getWithRest(rest_url: string) : Promise<Section_entry_fee[]> {
    return new Promise((resolve, reject) => {
      return this.http.get(AppSettings.API_ENDPOINT + 'accounting/entry_fees/' + rest_url).subscribe((response:any) => {

        if((response.type == 'section_entry_fees' || response.type == 'competition_entry_fees') && response.data){
          resolve(response.data);
        } else {
          reject(response);
        }

      },
        error_response => {
            if(error_response instanceof HttpErrorResponse){
              reject(error_response.error);
            }
            reject(error_response);
      });
    });
  }

}
